var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.url && _vm.url.length > 0)?_c('v-btn',{attrs:{"icon":"","tile":"","id":_vm.data.name,"target":"_blank","href":_vm.urlPath}},[_c('v-icon',{attrs:{"large":"","color":_vm.data.color}},[_vm._v(" "+_vm._s(_vm.data.icon)+" ")])],1):_vm._e(),(_vm.data.name == 'error')?_c('a',[_vm._v("Unknown")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }